<script setup>
import { computed } from 'vue';
import { useField } from 'vee-validate';

const props = defineProps({
    id: {
        type: String,
        default: undefined
    },
    // Nome do campo no schema do useForm. Quando informado, o componente se conecta
    // sozinho ao formulário pai (valor e erro), dispensando v-model e :erro.
    name: {
        type: String,
        default: null
    },
    erro: {
        type: String,
        default: null
    },
    modelValue: {
        type: String,
        default: ''
    },
    classeColuna: {
        type: String,
        default: 'col-12'
    },
    disabled: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['update:modelValue']);

// O BaseCadastros desmonta o formulário enquanto carrega: sem manter o valor, a data padrão
// (initialValues do useForm) seria apagada e o campo voltaria vazio.
const campoForm = props.name ? useField(props.name, undefined, { keepValueOnUnmount: true }) : null;

const data = computed({
    get: () => (campoForm ? campoForm.value.value : props.modelValue) ?? '',
    set: (value) => {
        if (campoForm) campoForm.value.value = value;
        emit('update:modelValue', value);
    }
});

const mensagemErro = computed(() => props.erro ?? campoForm?.errorMessage.value ?? null);
</script>

<template>
    <div class="field mb-2 flex flex-column gap-1" :class="props.classeColuna">
        <SmallTitle titulo="Data de pagamento" obrigatorio help="Data sugerida para que o pagamento seja realizado." />
        <InputMask :id="props.id" v-model="data" mask="99/99/9999" placeholder="99/99/9999" class="w-full text-sm"
            :disabled="props.disabled" :class="{ 'p-invalid': mensagemErro }" />
        <SmallError v-if="mensagemErro" :error="mensagemErro" />
    </div>
</template>
